import CardRole from 'txp-data/lib/schema/innerSchema/CardRole';
import isInvoiceSupported from 'owa-txp-common/lib/utils/featureChecks/isInvoiceSupported';
import isServiceReservationSupported from 'owa-txp-common/lib/utils/featureChecks/isServiceReservationSupported';
import TxpConfiguration from 'txp-data/lib/schema/configSchema/TxpConfiguration';
import { populateOwaDateTimeCallbacks } from '../actions/populateOwaDateTimeCallbacks';
import { TxpDatapoint, CardItem } from 'txp-data';

export default function createTxpConfiguration(
    isInvoiceSupportedProp: boolean,
    entityNamesMap: number,
    showActionButtons: boolean,
    isServiceReservationSupportedProp: boolean,
    cardRole?: CardRole,
    isEditableCardSupportedProp?: boolean,
    datapointLogger?: (
        txpDatapoint: TxpDatapoint,
        datapointName: string,
        internetMessageId?: string
    ) => void,
    onViewInMailClicked?: () => void,
    getLocationControl?: (showFullAddress: boolean, telephone?: string) => JSX.Element,
    onReportIssueClicked?: (feedbackType: string, feedbackLocationName: string) => void,
    onEventsFromEmailSettingsClicked?: (cardItem: CardItem) => void,
    onAddToCalendarClicked?: () => void,
    onRemoveFromCalendarClicked?: () => void,
    getCalendarDeepLinkUrl?: (calendarEventId: string) => string
): TxpConfiguration {
    let txpConfiguration: TxpConfiguration = {
        isEditableCardEnabled: isEditableCardSupportedProp,
        isInvoiceEnabled: isInvoiceSupportedProp
            ? isInvoiceSupportedProp
            : isInvoiceSupported(entityNamesMap),
        isServiceReservationEnabled: isServiceReservationSupportedProp
            ? isServiceReservationSupportedProp
            : isServiceReservationSupported(entityNamesMap),
        showActionButtons: showActionButtons,
        cardRole: cardRole,
        onViewInMailClicked: onViewInMailClicked,
        onReportIssueClicked: onReportIssueClicked,
        onEventsFromEmailSettingsClicked: onEventsFromEmailSettingsClicked,
        onAddToCalendarClicked: onAddToCalendarClicked,
        onRemoveFromCalendarClicked: onRemoveFromCalendarClicked,
        getCalendarDeepLinkUrl: getCalendarDeepLinkUrl,
        getLocationControl: getLocationControl,
        datapointLogger: datapointLogger,
        txpDateTimeCallbacks: populateOwaDateTimeCallbacks(),
    };

    return txpConfiguration;
}
